var map = {
	"./decidim/decidim_awesome/handcard.svg": "./vendor/ruby/3.2.0/bundler/gems/decidim-module-decidim_awesome-f2c71529cfb3/app/packs/images/decidim/decidim_awesome/handcard.svg",
	"./decidim/decidim_awesome/handcheck.svg": "./vendor/ruby/3.2.0/bundler/gems/decidim-module-decidim_awesome-f2c71529cfb3/app/packs/images/decidim/decidim_awesome/handcheck.svg",
	"./decidim/decidim_awesome/pokecode-logo.png": "./vendor/ruby/3.2.0/bundler/gems/decidim-module-decidim_awesome-f2c71529cfb3/app/packs/images/decidim/decidim_awesome/pokecode-logo.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./vendor/ruby/3.2.0/bundler/gems/decidim-module-decidim_awesome-f2c71529cfb3/app/packs/images sync recursive ^\\.\\/.*$";